<template>
  <div class="main-container simple__view">
    <header>
        <div class="containerTitle">
            <h1>{{translationArray.success}}</h1>
        </div>

        <div class="containerPartner">
            <div class=" partnerBox partnerBox__Right">
                <img src="../../static/img/senzu.png" alt="">
            </div>
            <p>{{translationArray.look_desktop}}</p>
            <p class="fontWeightNormal">{{translationArray.end_auth_desktop}}</p>
        </div>
        <div class="containerDescription">
            
        </div>
    </header>
  </div>
</template>

<script>
    import {translate} from '../../static/js/translate';

    export default {
        name: 'Error',
        data() {
            return {
                translationArray: {},
                csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        mounted() {
            this.translationArray = translate(navigator.language.substr(0, 2));
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Success.vue